var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.page ? _c('div', [_c('vue-title', {
    attrs: {
      "title": "Teams - Whoosh! Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "teams-main teams-page-wrap clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-12"
  }, [_c('TeamList', {
    attrs: {
      "teams": _vm.publicTeams,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "team-detail-base-url": _vm.teamDetailBaseUrl,
      "is-my-teams": false
    },
    on: {
      "page-changed": _vm.handlePageChange
    }
  })], 1)])])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }